import React from 'react';

export const VIEW = {
  STAT_CARD: 'statCard',
  STAT_ROW: 'statRow',
};

export const DATA_COLOR = {
  RED: '#e03546',
  GREEN: '#318616',
  GREY: '#52525b ',
};

const DataCard = ({
  heading = '',
  headingRight = '',
  icon = null,
  view = VIEW.STAT_CARD,
  stats = [],
  content = null,
}) => {
  return (
    <div className='tw-flex tw-flex-col tw-border-solid tw-border-[1px] tw-rounded-[8px] tw-border-grey-200 !tw-bg-white'>
      {(heading || headingRight) && (
        <span className='tw-leading-none tw-whitespace-nowrap tw-border-solid tw-border-[1px] tw-border-grey-200 tw-border-x-0 tw-border-t-0 tw-p-4 tw-bg-grey-200/20 tw-rounded-t-[8px] tw-flex tw-items-center tw-gap-2 tw-justify-between'>
          <div className='tw-text-[1.3rem] tw-font-medium tw-text-zinc-600 tw-flex tw-items-center tw-gap-2'>
            {icon} {heading}
          </div>
          <div className='tw-text-[1.3rem] tw-font-medium tw-text-zinc-600 tw-flex tw-items-center tw-gap-2'>
            {headingRight}
          </div>
        </span>
      )}
      {view === VIEW.STAT_CARD && (
        <div className='tw-flex tw-items-center'>
          {Array.isArray(stats) && stats?.length > 0 ? (
            stats.map(
              (
                { title, value, color = DATA_COLOR.GREY, style = {} },
                idx,
                stats,
              ) => {
                return (
                  <div
                    className={`tw-flex tw-flex-col tw-p-4 tw-gap-4 tw-w-full tw-border-solid tw-border-[1px] tw-border-grey-200 tw-border-y-0 ${
                      idx === stats.length - 1
                        ? 'tw-border-x-0'
                        : 'tw-border-l-0'
                    }`}
                    key={`${title}-${idx}`}
                    style={style}
                  >
                    {title && (
                      <span className='tw-text-[1.4rem] tw-font-medium tw-text-zinc-600 tw-leading-none tw-whitespace-nowrap tw-flex tw-items-center tw-gap-2'>
                        {title}
                      </span>
                    )}
                    {typeof value === 'string' || typeof value === 'number' ? (
                      <span
                        className='tw-font-medium tw-leading-none tw-text-[2.2rem] tw-h-fit'
                        style={{
                          color: color,
                        }}
                      >
                        {value}
                      </span>
                    ) : (
                      value
                    )}
                  </div>
                );
              },
            )
          ) : (
            <div className='tw-p-4 tw-text-zinc-400 tw-text-[1.3rem]'>
              No data found.
            </div>
          )}
        </div>
      )}
      {view === VIEW.STAT_ROW && content}
    </div>
  );
};

export default DataCard;
